import {
    IProductsTaxSystemItem
} from "@/entity/warehouse/Products/TaxSystem/TaxSystem.types"


export default class ProductsTaxSystemTypes implements IProductsTaxSystemItem{
    id: number | null
    name: string
    default: boolean

    constructor(data: IProductsTaxSystemItem) {
        this.id = data.id
        this.name = data.name
        this.default = data.default

    }
}